import { render, staticRenderFns } from "./DeathsView.vue?vue&type=template&id=97e1d070&"
import script from "./DeathsView.vue?vue&type=script&lang=js&"
export * from "./DeathsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports